import styled from"@emotion/styled";import{css}from"@emotion/react";import{HelperMessage}from"@wp/src/components/common/atoms";export const ManualPortfolioImportButtonsContainer=styled.div`
  display: ${props=>props.displayMode==="vertical"?"block":"flex"};
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
  justify-content: center;

  ${props=>props.fillWidth?css`
          & {
            width: 100%;
          }
        `:""}

  & > button.ant-btn {
    margin-bottom: ${props=>props.displayMode==="vertical"?"8px":"none"};
  }
`;export const AIImporterLoaderMessage=styled(HelperMessage)`
  color: inherit;
`;